import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  applicationHistoryKey,
  applicationsCountsKey,
  employerApplicationsKey,
  errorMessage,
  inviteToInterviewBlocksRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { eventsInterviewKey } from '@features/events';

type UseInviteToInterviewBlocksProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useInviteToInterviewBlocks = ({
  setErrorText,
}: UseInviteToInterviewBlocksProps) => {
  const client = useQueryClient();

  const {
    mutate: inviteToInterviewBlocks,
    isLoading: isInviteToInterviewBlocksLoading,
  } = useMutation({
    mutationFn: (variables: {
      user_id: number;
      application_id: number;
      body: string;
    }) =>
      axiosInstance
        .post(inviteToInterviewBlocksRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries(employerApplicationsKey);
        client.invalidateQueries(applicationsCountsKey);
        client.invalidateQueries(eventsInterviewKey);
        client.invalidateQueries(applicationHistoryKey);
        setErrorText('');
      } else {
        setErrorText(data?.message || errorMessage);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });
  return {
    inviteToInterviewBlocks,
    isInviteToInterviewBlocksLoading,
  };
};
